module.exports = __webpack_public_path__ + "img/info.45fdf1f0.svg";